
const customSelectors = {};
class customJS {
    constructor() {

        let templateSuffix = document.querySelector('body').getAttribute('data-suffix');
        if(templateSuffix === 'lab-results' || templateSuffix === 'faq'){
            setTimeout(() => {
                this._scrollsectionActive();
                this._manageScrollEvent();
            }, 1000);
            // this._hideShowCollectionContainerEle();
        }
    }

    _hideShowCollectionContainerEle(){
        document.querySelectorAll('[data-section-scroll]').forEach((ele)=>{
            if (ele.querySelector('[data-product-grid]') == null) {
                ele?.classList.add('d-none')
            }
        })
    }
    _manageScrollEvent() {
        try{
            let self = this;
            this.click = false;
            document.querySelectorAll('[data-scroll-to]:not(.d-none)').forEach((ele) => {
                ele.addEventListener('click', (event) => {
                    event.preventDefault();
                    let collectionName = ele.getAttribute('data-scroll-to');
                    const element = document.querySelector(`[data-scroll-call="${collectionName}"]:not(.d-none)`);
                    const previousSibling = element?.previousElementSibling;
                    let collectionOffset = 0;
                    let previousSiblingBottomSpacing = previousSibling?.getBoundingClientRect().bottom || 0;
                    let currentElementTopSpacing = element?.getBoundingClientRect().top;
                    let distance = currentElementTopSpacing - previousSiblingBottomSpacing;
                    if (window.innerWidth >= 992) {
                        collectionOffset = (previousSibling ? (previousSibling.offsetTop + previousSibling.offsetHeight + distance -  document.querySelector('sticky-header').offsetHeight) : (element.offsetTop - document.querySelector('sticky-header').offsetHeight - 60));
                    } else {
                        collectionOffset = (previousSibling ? (previousSibling.offsetTop + previousSibling.offsetHeight - 56) : (element.offsetTop - document.querySelector('sticky-header').offsetHeight - 60));
                    }
        
                    self.click = true;
                    self._manegeScrollExperience(collectionName);
        
                    if (typeof collectionOffset !== 'undefined') {
                        window.scroll(0, collectionOffset);
                    }
        
                    setTimeout(() => {
                        self.click = false;
                    }, 1000);
                });
            });
        }catch(err){
            console.error(err,'error');
            Utility._rollBar(err);
        }
    }

    _scrollsectionActive(){
        try{
            document.addEventListener('scroll', (event) => {
                event.preventDefault();
                if (!this.click) {
                    Array.from(document.querySelectorAll('[data-scroll-call]:not(.d-none) h2')).reverse().forEach(ele=>{
                        let isInViewPort = Utility.in_Viewport(ele);
                        if (isInViewPort) {
                            let collectionName = ele.closest('[data-scroll-call]:not(.d-none)')?.getAttribute('data-scroll-call');
                            this._manegeScrollExperience(collectionName);
                        }
                    })
                }
    
                let stickybar_wrapper = document.querySelector('.coll-stick');
                if (!Utility.in_Viewport(document.querySelector('.collection-banner__caption .trigger'))) {
                    stickybar_wrapper?.classList.add('stick-lab-results')
                }else{
                    stickybar_wrapper?.classList.remove('stick-lab-results')
                }
            });
        }catch(err){
            console.error(err,'error');
            Utility._rollBar(err);
        }
    }

    _manegeScrollExperience(collectionName){
        try{
            document.querySelector('[data-scroll-to].active:not(.d-none)')?.classList.remove('active');
            document.querySelector(`[data-scroll-to="${collectionName}"]:not(.d-none)`)?.classList.add('active');
            
            const matchedStickyItem = document.querySelector(`[data-scroll-to="${collectionName}"]:not(.d-none)`);
            var rect = matchedStickyItem?.getBoundingClientRect();
            var firstElementRect = document.querySelector(`[data-scroll-to]:not(.d-none)`)?.getBoundingClientRect();
            if (firstElementRect && matchedStickyItem && !Utility.isFullyVisible(matchedStickyItem?.querySelector('a'))) {
                document.querySelector('.stickybar_wrapper').scrollLeft=rect.left - firstElementRect.left;
            }
        }catch(err){
            console.error(err,'error');
            Utility._rollBar(err);
        }
    }
}

typeof customJS !== 'undefined' && new customJS();
